import vInpageLinks from "./v-inpage-links.vue";

export default Vue => {
  Vue.component("v-inpage-links", vInpageLinks);
};
